import axios from 'axios';

/**
 * Delta-only form version history API.
 * Mirrors the `/api/document-version` endpoints.
 */
export const documentVersionService = {
    // Record pending edits into the open draft (fire-and-forget, fired on blur).
    captureChanges: (body) => axios.post(`/document-version/changes`, body, { auth: true }),

    // Published version list for the history panel.
    listVersions: (params) => axios.get(`/document-version/list`, { auth: true, params }),

    // Working draft view (saved form + unsaved deltas) — used on form reopen.
    getDraftState: (params) => axios.get(`/document-version/draft-state`, { auth: true, params }),

    // Discard the open draft (drop unsaved changes).
    discardDraft: (params) => axios.delete(`/document-version/draft`, { auth: true, params }),

    // Full deltas of one version (expandable row / diff).
    getVersion: (id) => axios.get(`/document-version/detail/${id}`, { auth: true }),

    // Reconstructed full form state at a version (read-only preview).
    reconstruct: (params) => axios.get(`/document-version/reconstruct`, { auth: true, params }),

    // Restore an earlier version (creates a new version).
    restore: (body) => axios.post(`/document-version/restore`, body, { auth: true }),
};
